import React, { useState } from 'react'
import CollectionGraph from './CollectionGraph'
import StatsElement from './StatsElement'

function CollectionComponent(props) {
    const CHART_RANGE_PARAM = 'graphChartRange'

    const [chartRange, setChartRange] = useState(props[CHART_RANGE_PARAM] || 60)
    const [volumeType, setVolumeType] = useState('all')
    const [currency, setCurrency] = useState('usd')

    const chartDropDownOptions = [
        { value: 7, label: '7 Days' },
        { value: 15, label: '15 Days' },
        { value: 30, label: '30 Days' },
        { value: 60, label: '60 Days' },
        { value: 90, label: '90 Days' },
        { value: 180, label: '180 Days' },
        { value: 365, label: '365 Days' },
    ]

    const onChartRangeChange = (e) => {
        setChartRange(e.target.value)
    }

    const selectVolumeType = (target) => {
        setVolumeType(target)
    }

    return (
        <StatsElement
            title={''}
            chartRange={chartRange}
            onChange={onChartRangeChange}
            chartDropDownOptions={chartDropDownOptions}
            selectVolumeType={selectVolumeType}
            volumeType={volumeType}
            currency={currency}
            setCurrency={setCurrency}
            {...props}
        >
            <div className="relative w-full mb-auto">
                <CollectionGraph
                    {...props}
                    volumeType={volumeType}
                    chartRange={chartRange}
                    currency={currency}
                />
            </div>
        </StatsElement>
    )
}

export default CollectionComponent
